/** @format */

import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { _$, Drawer, Form, FormItem, Input, Transfer, Message } from '@king-design/react'
import { ContactGroupDrawerProps, updateGroupProps, initConstactGroupForm } from './constants'
import { cloneDeep, isEqual } from 'lodash'
import API from 'src/api/ApiContacts'
import { request } from 'src/utils'

const ContactGroupDrawer: React.FC<ContactGroupDrawerProps> = ({
  className,
  visible,
  closeDrawer,
  curGroup,
  userList
}) => {
  const [formValues, setFormValues] = useState<updateGroupProps>(initConstactGroupForm)
  const formRef = useRef<any>()
  // 初始化
  useEffect(() => {
    if (visible) {
      if (curGroup.usrgrpid) {
        const { name, description, contactIds } = curGroup
        setFormValues({
          ...formValues,
          Name: name,
          Description: description,
          UserIdList: contactIds.map(item => item.userid)
        })
      }
    } else {
      // 关闭：清空form
      setFormValues(initConstactGroupForm)
    }
  }, [visible])

  // 修改formValues
  const changeFormValues = values => {
    setFormValues({
      ...formValues,
      ...values
    })
  }

  // 提交
  const formSubmit = async () => {
    const validate = await formRef?.current?.validate()
    if (validate) {
      const params = cloneDeep(formValues)
      if (params.UserIdList.length) {
        const url = curGroup.usrgrpid ? API.updateUserGroup : API.createUserGroup
        if (curGroup.usrgrpid) {
          params.UserGrpId = curGroup.usrgrpid
        }
        const result = await request(url, {
          method: 'POST',
          data: params
        })
        const { code, message } = result
        if (code === 'Success') {
          Message.success(message)
          closeDrawer(true)
        }
      } else {
        Message.error(_$('联系组需至少包含一个联系人'))
      }
    }
  }

  return (
    <Drawer
      width={800}
      value={visible}
      title={curGroup?.usrgrpid ? _$('修改联系组') : _$('新建联系组')}
      onClose={() => {
        closeDrawer()
      }}
      cancel={() => {
        closeDrawer()
      }}
      disabledOk={formValues?.UserIdList?.length < 1}
      ok={() => {
        formSubmit()
      }}
    >
      <div className={className}>
        <Form starOnRequired={true} ref={formRef} labelWidth={100}>
          <FormItem
            label={_$('联系组名称')}
            value={formValues.Name}
            rules={{
              required: true,
              userName: true
            }}
          >
            <Input
              value={formValues.Name}
              onChangeValue={value => {
                changeFormValues({
                  Name: value
                })
              }}
            />
          </FormItem>
          <FormItem
            label={_$('描述')}
            value={formValues.Description}
            rules={{
              maxLength: 100
            }}
          >
            <Input
              value={formValues.Description}
              onChangeValue={value => {
                changeFormValues({
                  Description: value
                })
              }}
            />
          </FormItem>
          <FormItem label={_$('联系人')} value={formValues.UserIdList}>
            <Transfer
              data={userList?.map(item => ({
                label: item.name,
                key: item.userid
              }))}
              value={formValues.UserIdList}
              filterable
              onChangeValue={(value, oldValue) => {
                const equal = isEqual(value, oldValue)
                if (!equal) {
                  changeFormValues({
                    UserIdList: value
                  })
                }
              }}
            ></Transfer>
          </FormItem>
        </Form>
      </div>
    </Drawer>
  )
}
export default styled(ContactGroupDrawer)``
